module.exports = __webpack_public_path__ + "static/media/logo-text.e9b39d28.png";